// useQueryParams.ts
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { getSolutionType } from "../utils/fetchQueryUtil";
import { useAppSelector } from "../store/hooks";
import { GanttTabBarTab } from "../types/ganttChart";
import { SolutionType } from "../store/realTimeUpdates";

export type PlanViewKey = {
  solutionType?: SolutionType;
  filterId?: number;
  date?: string;
};

/**
 * Hook til at hente query params relevant for plan view
 */
export const useQueryParams = (selectedTab?: GanttTabBarTab) => {
  const [searchParams] = useSearchParams();
  const dateParam = searchParams.get("date") || undefined;
  const filterParam = searchParams.get("filter") || undefined;

  const { selectedGanttChartTab } = useAppSelector(
    (state) => state.ganttChartSlice
  );

  // Memoize queryKey for stabilitet
  const queryKey = useMemo<PlanViewKey>(() => {
    const filterId = filterParam ? parseInt(filterParam) : undefined;
    const solutionType = selectedTab
      ? getSolutionType(selectedTab)
      : getSolutionType(selectedGanttChartTab);

    return {
      solutionType,
      filterId,
      date: dateParam,
    };
  }, [filterParam, dateParam, selectedGanttChartTab, selectedTab]);

  return queryKey;
};
